module.exports = __webpack_public_path__ + "img/img-2.573230e2.png";